export const DollarFilledIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.625 13.2666H11.1667C11.7083 13.2666 12.1583 12.7833 12.1583 12.1999C12.1583 11.4749 11.9 11.3333 11.475 11.1833L10.6333 10.8916V13.2666H10.625Z"
        fill="currentColor"
      />
      <path
        d="M9.97489 1.58327C5.37489 1.59993 1.64989 5.3416 1.66656 9.9416C1.68323 14.5416 5.42489 18.2666 10.0249 18.2499C14.6249 18.2333 18.3499 14.4916 18.3332 9.8916C18.3166 5.2916 14.5749 1.57493 9.97489 1.58327ZM11.8832 9.99993C12.5332 10.2249 13.4082 10.7083 13.4082 12.1999C13.4082 13.4833 12.3999 14.5166 11.1666 14.5166H10.6249V14.9999C10.6249 15.3416 10.3416 15.6249 9.99989 15.6249C9.65823 15.6249 9.37489 15.3416 9.37489 14.9999V14.5166H9.07489C7.70823 14.5166 6.59989 13.3666 6.59989 11.9499C6.59989 11.6083 6.88323 11.3249 7.22489 11.3249C7.56656 11.3249 7.84989 11.6083 7.84989 11.9499C7.84989 12.6749 8.39989 13.2666 9.07489 13.2666H9.37489V10.4499L8.11656 9.99993C7.46656 9.77493 6.59156 9.2916 6.59156 7.79993C6.59156 6.5166 7.59989 5.48327 8.83323 5.48327H9.37489V4.99993C9.37489 4.65827 9.65823 4.37493 9.99989 4.37493C10.3416 4.37493 10.6249 4.65827 10.6249 4.99993V5.48327H10.9249C12.2916 5.48327 13.3999 6.63327 13.3999 8.04993C13.3999 8.3916 13.1166 8.67493 12.7749 8.67493C12.4332 8.67493 12.1499 8.3916 12.1499 8.04993C12.1499 7.32493 11.5999 6.73327 10.9249 6.73327H10.6249V9.54993L11.8832 9.99993Z"
        fill="currentColor"
      />
      <path
        d="M7.8501 7.8084C7.8501 8.5334 8.10843 8.67507 8.53343 8.82507L9.3751 9.11673V6.7334H8.83343C8.29176 6.7334 7.8501 7.21673 7.8501 7.8084Z"
        fill="currentColor"
      />
    </svg>
  )
}
